module.exports = __webpack_public_path__ + "img/b12.4f219ea9.png";